import { metersToMiles } from '@alltrails/data-formatting';
import { toATLocalString } from '@alltrails/core/utils/toATLocalString';
import Stats from '@alltrails/core/types/Stats';
import type { LanguageRegionCode } from '@alltrails/types/LanguageRegionCode';

const ONE_BILLION = 1000000000;

// Helper function to format the logged distance in miles or kilometers for alltrails landing pages

const formatLoggedDistance = (languageRegionCode: LanguageRegionCode, displayMetric = false) => {
  const distance = displayMetric ? Stats.LoggedDistanceMeters / 1000 : metersToMiles(Stats.LoggedDistanceMeters);

  return toATLocalString(Math.round(distance) / ONE_BILLION, languageRegionCode, 1);
};

export default formatLoggedDistance;
